import React from 'react';
import { CrudStyles } from './Crud';
import { formatZipDisplay } from '../../utils/mapAddressFromApi';

const { SectionTitle, FormGroup } = CrudStyles;

const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: '#555',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
};

const valueStyle = {
    margin: 0,
    fontSize: 15,
    color: '#1a1a1a',
    lineHeight: 1.5,
    overflowWrap: 'anywhere',
    wordBreak: 'normal',
};

/** Duas colunas iguais (complemento / bairro, cidade / UF). */
const rowTwoCol = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: 16,
    width: '100%',
    minWidth: 0,
};

const fullWidth = {
    width: '100%',
    minWidth: 0,
};

const addressBlock = {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
    minWidth: 0,
};

const highlightShell = {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    padding: '16px 20px 20px',
    borderRadius: 12,
    background: 'linear-gradient(165deg, #eff6ff 0%, #f8fafc 45%, #ffffff 100%)',
    border: '1px solid #93c5fd',
    boxShadow: '0 2px 8px rgba(37, 99, 235, 0.08)',
};

function Field({ label, children }) {
    return (
        <FormGroup style={{ minWidth: 0 }}>
            <span style={labelStyle}>{label}</span>
            <div style={valueStyle}>{children}</div>
        </FormGroup>
    );
}

/**
 * @param {string|null|undefined} street
 * @param {string|number|null|undefined} number
 * @returns {string}
 */
function formatStreetAndNumber(street, number) {
    const s = street != null ? String(street).trim() : '';
    const n = number != null && number !== '' ? String(number).trim() : '';
    if (!s && !n) return '—';
    if (s && !n) return s;
    if (!s && n) return `N° ${n}`;
    return `${s}, N° ${n}`;
}

/**
 * Bloco somente leitura de endereço (CEP, logradouro, etc.).
 * @param {Object} props
 * @param {Object|null} props.address
 * @param {string} props.title
 * @param {'default'|'highlight'} [props.variant]
 */
export default function ReadOnlyAddressFields({ address, title, variant = 'default' }) {
    const a = address || {};
    const inner = (
        <>
            <SectionTitle>{title}</SectionTitle>
            <div style={addressBlock}>
                {a.name ? (
                    <div style={fullWidth}>
                        <Field label="Nome">{a.name}</Field>
                    </div>
                ) : null}
                <div style={fullWidth}>
                    <Field label="CEP">{formatZipDisplay(a.zipCode)}</Field>
                </div>
                <div style={fullWidth}>
                    <Field label="Rua e número">{formatStreetAndNumber(a.street, a.number)}</Field>
                </div>
            </div>
            <div style={rowTwoCol}>
                <Field label="Complemento">{a.complement || '—'}</Field>
                <Field label="Bairro">{a.district || '—'}</Field>
            </div>
            <div style={rowTwoCol}>
                <Field label="Cidade">{a.city || '—'}</Field>
                <Field label="UF">{a.stateAbbr || '—'}</Field>
            </div>
        </>
    );

    if (variant === 'highlight') {
        return <div style={highlightShell}>{inner}</div>;
    }

    return <div style={{ width: '100%', minWidth: 0 }}>{inner}</div>;
}
